import { useState } from 'react';
import Icon from '@klv/atoms/icon';
import { Tooltip, TooltipTrigger, TooltipContent } from '@klv/atoms/tooltip';
import * as styles from './styles/slider.module.css';
import type { IInfoToolTip } from './types';

export const InfoToolTip = ({
  subText,
  subTextInfo,
  subTextInfoHeader,
  variant,
}: IInfoToolTip) => {
  const [open, setOpen] = useState(false);

  return (
    <div className={variant === 'platform' ? styles.platformInfoToolTipContainer : styles.infoToolTipContainer}>
      <span className={variant === 'platform' ? styles.platformSubText : styles.subText}>
        {subText}
        <Tooltip open={open} onOpenChange={setOpen}>
          {subTextInfoHeader && (
            <TooltipTrigger asChild onClick={() => setOpen((v) => !v)}>
              <span className={styles.iconWrapper}>
                <Icon iconName="InformationOutline" fill="var(--color-core-eggplant)" />
              </span>
            </TooltipTrigger>
          )}
          <TooltipContent className={styles.tooltipContent}>
            {subTextInfoHeader && (
              <div className={styles.subTextInfoHeader}>{subTextInfoHeader}</div>
            )}
            {subTextInfo && <p className={styles.subTextInfo}>{subTextInfo}</p>}
          </TooltipContent>
        </Tooltip>
      </span>
    </div>
  );
};
